import React, { useEffect } from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 'testimonial-1',
      text: "The Clean Knight Co. transformed our home's exterior! The pressure washing service removed years of grime from our driveway and patio. Highly recommended!",
      author: 'Sarah Johnson',
      role: 'Homeowner',
      image: 'https://images.unsplash.com/photo-1512849934327-1cf5bf8a5ccc?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8ZmFjZXN8ZW58MHx8MHx8fDA%3D'
    },
    {
      id: 'testimonial-2',
      text: "Professional, punctual, and thorough. The team at The Clean Knight Co. did an amazing job cleaning our gutters and windows. Our home looks brand new!",
      author: 'Michael Brown',
      role: 'Property Manager',
      image: 'https://media.istockphoto.com/id/2166802740/photo/confident-businessman-smiling-in-sunlit-urban-environment.webp?a=1&b=1&s=612x612&w=0&k=20&c=e__SfARZdjjTvtDsGfmDDsL14GUwTCgstLZVMTqb1L4='
    },
    {
      id: 'testimonial-3',
      text: "I've used many cleaning services before, but The Clean Knight Co. stands out for their attention to detail and excellent customer service. 5 stars!",
      author: 'Emily Davis',
      role: 'Real Estate Agent',
      image: 'https://images.unsplash.com/photo-1604904612715-47bf9d9bc670?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGJ1c2luZXNzJTIwcG9ydHJhaXR8ZW58MHx8MHx8fDA%3D'
    }
  ];

  useEffect(() => {
    // Add drag scrolling functionality for testimonials on desktop
    const testimonialsContainer = document.querySelector('.testimonials-container');
    
    if (testimonialsContainer && window.innerWidth >= 768) {
      let isDown = false;
      let startX;
      let scrollLeft;

      const handleMouseDown = (e) => {
        isDown = true;
        testimonialsContainer.style.cursor = 'grabbing';
        startX = e.pageX - testimonialsContainer.offsetLeft;
        scrollLeft = testimonialsContainer.scrollLeft;
      };

      const handleMouseLeave = () => {
        isDown = false;
        testimonialsContainer.style.cursor = 'grab';
      };

      const handleMouseUp = () => {
        isDown = false;
        testimonialsContainer.style.cursor = 'grab';
      };

      const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - testimonialsContainer.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        testimonialsContainer.scrollLeft = scrollLeft - walk;
      };

      testimonialsContainer.addEventListener('mousedown', handleMouseDown);
      testimonialsContainer.addEventListener('mouseleave', handleMouseLeave);
      testimonialsContainer.addEventListener('mouseup', handleMouseUp);
      testimonialsContainer.addEventListener('mousemove', handleMouseMove);
      
      // Set initial cursor style
      testimonialsContainer.style.cursor = 'grab';

      // Cleanup
      return () => {
        if (testimonialsContainer) {
          testimonialsContainer.removeEventListener('mousedown', handleMouseDown);
          testimonialsContainer.removeEventListener('mouseleave', handleMouseLeave);
          testimonialsContainer.removeEventListener('mouseup', handleMouseUp);
          testimonialsContainer.removeEventListener('mousemove', handleMouseMove);
        }
      };
    }
  }, []);

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials-header animate-on-scroll">
        <h2>What Our Clients Say</h2>
        <p>Don't just take our word for it - hear from our satisfied customers.</p>
      </div>
      <div className="testimonials-container">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card animate-on-scroll">
            <p>"{testimonial.text}"</p>
            <div className="testimonial-author">
              <div 
                className="author-img" 
                style={{ backgroundImage: `url('${testimonial.image}')` }}
              ></div>
              <div className="author-details">
                <h4>{testimonial.author}</h4>
                <p>{testimonial.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
// /**
//  * Testimonials Component
//  * Renders the testimonials section with customer reviews
//  */

// const Testimonials = {
//   // Testimonials data - could be moved to a separate data file
//   testimonials: [
//     {
//       id: 'testimonial-1',
//       text: "The Clean Knight Co. transformed our home's exterior! The pressure washing service removed years of grime from our driveway and patio. Highly recommended!",
//       author: 'Sarah Johnson',
//       role: 'Homeowner',
//       image: 'https://images.unsplash.com/photo-1512849934327-1cf5bf8a5ccc?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8ZmFjZXN8ZW58MHx8MHx8fDA%3D'
//     },
//     {
//       id: 'testimonial-2',
//       text: "Professional, punctual, and thorough. The team at The Clean Knight Co. did an amazing job cleaning our gutters and windows. Our home looks brand new!",
//       author: 'Michael Brown',
//       role: 'Property Manager',
//       image: 'https://media.istockphoto.com/id/2166802740/photo/confident-businessman-smiling-in-sunlit-urban-environment.webp?a=1&b=1&s=612x612&w=0&k=20&c=e__SfARZdjjTvtDsGfmDDsL14GUwTCgstLZVMTqb1L4='
//     },
//     {
//       id: 'testimonial-3',
//       text: "I've used many cleaning services before, but The Clean Knight Co. stands out for their attention to detail and excellent customer service. 5 stars!",
//       author: 'Emily Davis',
//       role: 'Real Estate Agent',
//       image: 'https://images.unsplash.com/photo-1604904612715-47bf9d9bc670?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGJ1c2luZXNzJTIwcG9ydHJhaXR8ZW58MHx8MHx8fDA%3D'
//     }
//   ],

//   render: () => {
//     // Create testimonial cards HTML from the testimonials array
//     const testimonialCards = Testimonials.testimonials.map(testimonial => `
//       <div class="testimonial-card" id="${testimonial.id}">
//         <p>"${testimonial.text}"</p>
//         <div class="testimonial-author">
//           <div class="author-img" style="background-image: url('${testimonial.image}');"></div>
//           <div class="author-details">
//             <h4>${testimonial.author}</h4>
//             <p>${testimonial.role}</p>
//           </div>
//         </div>
//       </div>
//     `).join('');

//     return `
//       <section class="testimonials" id="testimonials">
//         <div class="testimonials-header">
//           <h2>What Our Clients Say</h2>
//           <p>Don't just take our word for it - hear from our satisfied customers.</p>
//         </div>
//         <div class="testimonials-container">
//           ${testimonialCards}
//         </div>
//       </section>
//     `;
//   },

//   setup: () => {
//     // Add drag scrolling functionality for testimonials on desktop
//     const testimonialsContainer = document.querySelector('.testimonials-container');
    
//     if (testimonialsContainer && window.innerWidth >= 768) {
//       let isDown = false;
//       let startX;
//       let scrollLeft;

//       testimonialsContainer.addEventListener('mousedown', (e) => {
//         isDown = true;
//         testimonialsContainer.style.cursor = 'grabbing';
//         startX = e.pageX - testimonialsContainer.offsetLeft;
//         scrollLeft = testimonialsContainer.scrollLeft;
//       });

//       testimonialsContainer.addEventListener('mouseleave', () => {
//         isDown = false;
//         testimonialsContainer.style.cursor = 'grab';
//       });

//       testimonialsContainer.addEventListener('mouseup', () => {
//         isDown = false;
//         testimonialsContainer.style.cursor = 'grab';
//       });

//       testimonialsContainer.addEventListener('mousemove', (e) => {
//         if (!isDown) return;
//         e.preventDefault();
//         const x = e.pageX - testimonialsContainer.offsetLeft;
//         const walk = (x - startX) * 2; // Scroll speed multiplier
//         testimonialsContainer.scrollLeft = scrollLeft - walk;
//       });
      
//       // Set initial cursor style
//       testimonialsContainer.style.cursor = 'grab';
//     }
//   }
// };

// export default Testimonials;